import { CourseSectionNameFragment } from "../../../Utilities";
import * as CourseFormat from "../Course";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: CourseSectionNameFragment) {
	return `${Fields.namePrefix(instance.namePrefix)}${CourseFormat.name(instance.course)}${Fields.nameSuffix(
		instance.nameSuffix,
	)}`;
}
